import { useState, useEffect, useCallback } from "react";
import { Input, InputGroup, InputGroupAddon } from "reactstrap";
import currencyToSymbolMap from "currency-symbol-map/map";
import _ from "underscore";
import getSymbolFromCurrency from "currency-symbol-map";

import { callFunctionIfExists } from "utils/GeneralUtils";

const Currency = ({ field, existingValue, onChange, inputSize, disabled }) => {
  const [Value, setValue] = useState(null);
  const [currency, setCurrency] = useState(
    existingValue?.Currency ? existingValue?.Currency : "USD"
  );

  const updateValue = useCallback(() => {
    if (typeof existingValue === "string") {
      return;
    }

    if (
      existingValue?.Value === null ||
      existingValue?.Value === undefined ||
      existingValue === null ||
      existingValue === undefined
    ) {
      return setValue("");
    }

    setValue(
      !isNaN(existingValue?.Value) ? parseFloat(existingValue?.Value) : ""
    );
    setCurrency(existingValue?.Currency ? existingValue.Currency : "USD");
  }, [existingValue]);

  const handleCurrencyChange = (event) => {
    const newCurrency = event.target.value;
    setCurrency(newCurrency);

    let payload = {
      Value: parseFloat(Value),
      Currency: newCurrency,
      Symbol: getSymbolFromCurrency(newCurrency),
    };

    callFunctionIfExists(onChange, payload);
  };

  useEffect(() => {
    updateValue();
  }, [updateValue]);

  const handleValueChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    let payload = {
      Value: newValue === "" || isNaN(newValue) ? null : parseFloat(newValue),
      Currency: currency,
      Symbol: getSymbolFromCurrency(currency),
    };

    callFunctionIfExists(onChange, payload);
  };

  const getCurrencyCodes = () => _.keys(currencyToSymbolMap);

  useEffect(() => {
    setValue(existingValue.Value);
  }, [existingValue]);

  return (
    <InputGroup>
      <InputGroupAddon style={{ height: "32px" }} addonType="prepend">
        {getSymbolFromCurrency(currency)}
      </InputGroupAddon>
      <Input
        id={`record-input-${field.APIName}`}
        style={{ height: "32px" }}
        onChange={handleValueChange}
        required={field?.Required}
        bsSize={inputSize ? inputSize : ""}
        type="text"
        value={Value || ""}
        disabled={disabled}
      ></Input>
      <InputGroupAddon addonType="append">
        <Input
          value={currency}
          onChange={handleCurrencyChange}
          style={{
            height: "32px",
            width: "110px",
            textOverflow: "ellipsis",
          }}
          bsSize="sm"
          type="select"
          className="form-control"
          disabled={disabled}
        >
          <option disabled={true} value="">
            Choose A Currency
          </option>
          {getCurrencyCodes().map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </Input>
      </InputGroupAddon>
    </InputGroup>
  );
};

export default Currency;
